import { AppStoreType, AppInternalType } from '~globals/types/enums';
import { toAbsoluteUrl } from '~utils/assetsHelpers';

interface AppStoreInfoItem {
  URLS: Record<AppInternalType, string>;
  NAME: string;
  IMAGE_URL: string;
}
type AppStoreInfo = Record<AppStoreType, AppStoreInfoItem>;

export const APP_STORES_INFO: AppStoreInfo = {
  PLAY_STORE: {
    URLS: {
      DRIVER: 'https://play.google.com/store/apps/details?id=com.routix',
      GESTION:
        'https://play.google.com/store/apps/details?id=com.antorcha.routixmgm',
      TIENDAS:
        'https://play.google.com/store/apps/details?id=com.antorchadigital.routix_giver',
    },
    NAME: 'Play Store',
    IMAGE_URL: toAbsoluteUrl('/icons/icon_google_play.svg'),
  },
  APP_STORE: {
    URLS: {
      DRIVER: 'https://apps.apple.com/us/app/routix/id1659539509',
      GESTION: 'https://apps.apple.com/ar/app/routix-gestión/id6757621512',
      TIENDAS: 'https://apps.apple.com/us/app/routix-tiendas/id6782991028',
    },
    NAME: 'App Store',
    IMAGE_URL: toAbsoluteUrl('/icons/icon_app_store.svg'),
  },
};
